// extracted by mini-css-extract-plugin
export default {"pageBody":"World1Task4Screen_pageBody__huRzQ","stage":"World1Task4Screen_stage__g10aB","questionTight":"World1Task4Screen_questionTight__rjvz+"};